import { isLink } from './isLink'
import { encodeMergeFieldBraces, stripMergeFieldTokens } from './mergeFieldUrl'

export const replaceLink = (link: string) => {
  if (isLink(link) || isLink(stripMergeFieldTokens(link))) {
    return `<a target='_blank' href='${encodeMergeFieldBraces(link)}' data-readonly>${link}</a>`
  }
  return link
}
